import { render, staticRenderFns } from "./BDProductVoucherModal.vue?vue&type=template&id=61630099&"
import script from "./BDProductVoucherModal.vue?vue&type=script&lang=js&"
export * from "./BDProductVoucherModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports